import dayjs, { ConfigType } from 'dayjs';

const dayjsTz = (date?: ConfigType) => dayjs(date).tz();

export default dayjsTz;
